// components/ErrorBoundaryReset.jsx
import { useLocation } from "react-router-dom";
import ErrorBoundary from "./ErrorBoundary";

export default function ErrorBoundaryReset({ children }) {
    const location = useLocation();
    // Cambiando la key al cambiare della location, il boundary viene rimontato (reset)
    return <ErrorBoundary key={location.key}>{children}</ErrorBoundary>;
}
